import { render, staticRenderFns } from "./tabs-scan.vue?vue&type=template&id=6ebfceff"
import script from "./tabs-scan.vue?vue&type=script&lang=js"
export * from "./tabs-scan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports